module.exports = __webpack_public_path__ + "img/banner.4d7bd2b5.jpeg";